import { BodyConverter } from '@iotize/tap/client/api';

export interface ArrayConverterOptions {
  /**
   * Size of one item in byte
   */
  sizeOfItem: number;
}

export class ArrayConverter<ItemType> implements BodyConverter<ItemType[]> {
  constructor(
    protected _itemConverter: BodyConverter<ItemType>,
    protected options: ArrayConverterOptions,
  ) {}

  get itemConverter(): BodyConverter<ItemType> {
    return this._itemConverter;
  }

  decode(bytes: Uint8Array): ItemType[] {
    let items: ItemType[] = [];
    let sizeOfItem = this.options.sizeOfItem;
    for (let offset = 0; offset < bytes.length; offset += sizeOfItem) {
      let slice = bytes.subarray(offset, offset + sizeOfItem);
      let item = this._itemConverter.decode(slice);
      items.push(item);
    }
    return items;
  }

  encode(items: ItemType[]) {
    let result = new Uint8Array(this.options.sizeOfItem * items.length);
    let offset = 0;
    for (let item of items) {
      let encodedItem = (this._itemConverter as any).encode(item); // TODO
      if (encodedItem.length > this.options.sizeOfItem) {
        throw new Error(
          `Encoded item size overflow: ${encodedItem.length} (max is ${this.options.sizeOfItem})`,
        );
      }
      result.set(encodedItem, offset);
      offset += this.options.sizeOfItem;
    }
    return result;
  }
}
